import $ from 'jquery';
import 'slick-carousel';

$('.js-slider').each(function () {
    var $slider = $(this);

    $slider.on('init', function () {
        setTimeout(function () {
            var $firstVideo = $slider.find('.slick-slide[data-slick-index="0"]').first().find('video');
            if ($firstVideo.length > 0) {
                if (!$firstVideo[0].paused) {
                    $slider.slick('slickPause');
                }
            }

            $slider.find('video').on('ended', function () {
                $slider.slick('slickPlay');
                $slider.slick('slickNext');
            })
        }, 200)

    });

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]')
        var $video = $nextSlide.find('video');
        if ($video.length > 0) {
            $video[0].play();
        }
    });

    $slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        var $currentSlide = $slider.find('.slick-slide[data-slick-index="' + currentSlide + '"]')
        var $video = $currentSlide.find('video');
        if ($video.length > 0) {
            if (!$video[0].paused) {
                $slider.slick('slickPause');
            }
        }
    });

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 7000,
        infinite: true,
        arrows: true,
        dots: false,
        draggable: true,
        rows: 0,
        prevArrow: '<button title="'+ window.translationStrings.prevSlide +'" class="slick-prev fa-thin fa-arrow-left"></button>',
        nextArrow: '<button title="'+ window.translationStrings.nextSlide +'" class="slick-next fa-thin fa-arrow-right"></button>',
        appendArrows: $('<div>', {class: 'js-slider__arrows'}).insertAfter($slider),
    });
});




